// This methods are placed in here instead of the personas modal and the other components because I think some of them will be shared
// between components.
import _ from 'lodash';
import PersonasDataProvider from './PersonasDataProvider';
import UserManager from '../../core/UserManager';
import { store } from '../../store/store';
import { selectAuthUser } from '../../store/authSlice';

const DEFAULT_PERSONA_SUB_KEY = 'list_filters';

export const PERSONA_SAVE_OVERLAY_MODE = {
	NO_PERSONA: 'no_persona',
	NOT_EDITABLE: 'not_editable'
};

export function getActivePersona() {
	const authUser = selectAuthUser(store.getState()) || {};
	return authUser?.persona || null;
}

export function canEditPersona(persona) {
	return Boolean(persona?.id && persona?.owned_by_user);
}

export function canEditActivePersona() {
	return canEditPersona(getActivePersona());
}

export function shouldPersistFiltersToPersona(persona = getActivePersona()) {
	return canEditPersona(persona);
}

export function getPersonaSaveOverlayMode(persona = getActivePersona()) {
	if (!persona?.id) return PERSONA_SAVE_OVERLAY_MODE.NO_PERSONA;
	if (!canEditPersona(persona)) return PERSONA_SAVE_OVERLAY_MODE.NOT_EDITABLE;
	return null;
}

// Reads a sub-key from the active persona's filter blob via Redux (the single source of truth).
// Use the same `namespace` / `subKey` you pass to `FiltersPopover` to read back what was saved.
export function getStoredPersonaFilters(namespace, subKey = DEFAULT_PERSONA_SUB_KEY) {
	if (!namespace) return {};
	const authUser = selectAuthUser(store.getState()) || {};
	const stored = authUser?.persona?.filters?.[namespace]?.[subKey];
	return stored && typeof stored === 'object' ? _.cloneDeep(stored) : {};
}

/** Push UserManager.user into Redux after the active persona (or its filters) changed. */
export function notifyActivePersonaChanged() {
	UserManager.syncAuthState();
}

export function loadPersonasOptions() {
	return PersonasDataProvider.getPersonasOptions();
}

export function createPersona(data) {
	const { setDefault, personaType, title, regions, isPublic, avatarImgURL, filters, platform, outerFilters } = data;
	let jsonBody = { setDefault, personaType, title, regions, isPublic, attributes: { icon: avatarImgURL },
		filters: { [platform.platformID]: { ...filters, ...outerFilters } } };
	jsonBody = _.mapKeys(jsonBody, (_v, k) => _.snakeCase(k));
	return PersonasDataProvider.createPersona(jsonBody);
}

export function updatePersona(data) {
	const { id, setDefault, personaType, title, regions, isPublic, avatarImgURL, filters, platform, currentFilters, outerFilters } = data;
	let jsonBody = { setDefault, personaType, title, regions, isPublic, attributes: { icon: avatarImgURL },
		filters: { ...currentFilters, [platform.platformID]: { ...filters, ...outerFilters }} };
	jsonBody = _.mapKeys(jsonBody, (_v, k) => _.snakeCase(k));
	return PersonasDataProvider.updatePersona(id, jsonBody);
}
